<template>
	<div class="container">
		<h2 class="text-center mt-5 mb-4 pb-2 bold">{{ $t('contact-us-header') }}</h2>
		<section class="contact-section my-5">
			<div class="container h-100">
				<div class="d-flex flex-column flex-lg-row h-100 mb-4">
					<div class="card-widths-1 h-100 d-flex justify-content-start align-items-center order-last order-lg-first">
						<!-- contact-us-form -->
						<div class="form-card-width rounded-4 card-shadow bg-white">
							<div class="contact-form-card p-5 px-5 pt-4 mt-2 pb-3">
								<!-- fix the font size -->
								<h5 class="contact-form-card-title section-title mb-4 pb-3" v-html="$t('contact-form.title')"></h5>
								<div class="my-3">
									<ContactForm :is-submitted="isFormSubmitted" @submitForm="submitForm" />
								</div>
							</div>
						</div>
					</div>
					<div class="card-widths-2 h-100 d-flex justify-content-center align-items-center order-first order-lg-last">
						<div class="py-4 h-90 w-100 d-flex flex-column align-items-center justify-content-center">
							<div class="h-50 w-100">
								<h4 class="section-title contact-info-title mb-3 mt-4 info-text-align" v-html="$t('homepage.contact-us-section.info-part.title')"></h4>
								<p class="contact-info-content mb-4 pb-2 info-text-align">{{ $t('homepage.contact-us-section.info-part.content') }}</p>
								<a
									:href="`https://wa.me/${contacts[0]?.whatsapp}`"
									target="_blank"
									class="button second-button tall-button mx-auto mx-md-0 text-decoration-none"
								>
									{{ $t('homepage.contact-us-section.info-part.button') }}
								</a>
							</div>
							<div class="w-100 my-3">
								<hr>
							</div>
							<div class="h-50 w-100">
								<div class="col-lg-4 col-md-4 col-12 mb-4 mb-lg-0 w-100">
									<h6 class="mb-4 d-flex justify-content-center justify-content-md-start bold other-info-title">
										{{ $t('homepage.contact-us-section.other-info.title') }}
									</h6>
									<div class="d-flex justify-content-center justify-content-md-start mb-4">
										<span class="other-info-content mb-3">
											{{contacts[0]?.address}}
										</span>
									</div>
									<div class="d-flex justify-content-center justify-content-md-start mb-1">
										<a :href="`tel:${contacts[0]?.phone}`" class="other-info-content text-decoration-none dark-blue-color">
											{{ $t('phone') }} : {{contacts[0]?.phone}}
										</a>
									</div>
									<div class="d-flex justify-content-center justify-content-md-start">
										<a :href="`mailto:${contacts[0]?.email}`" class="other-info-content text-decoration-none dark-blue-color">
											{{ $t('email') }} : {{contacts[0]?.email}}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
import { mapState } from 'vuex'

export default {
	components: {
		ContactForm
	},

	data () {
		return {
			isFormSubmitted: false
		}
	},

	computed: {
		...mapState({
			contacts: state => state.contacts.contacts
		})
	},

	methods: {
		submitForm (form) {
			this.$store.dispatch('feedback/createFeedback', form).then(() => {
				this.isFormSubmitted = true
			}).catch(() => {
				this.isFormSubmitted = false
			})
		},
	}
}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';
// major classes
.section-title {
	font-weight: 800;
	line-height: 1.65;
}

.section-title ::v-deep span {
	color: $secondary;
	font-weight: 900;
}

// contact section
.contact-section {
    // height: 575px;
	.card-widths-1 {
		width: 65%;
		@media (max-width: 992px) {
			width: 100%
		}

		.form-card-width {
			width: 92%;
			height: 92%;
			@media (max-width: 992px) {
				width: 100%;
				height: 100%;
			}
		}
	}
	.card-widths-2 {
		width: 45%;
		@media (max-width: 992px) {
			width: 100%
		}

		.contact-info-title {
			font-size: 20px;
		}
		.contact-info-content {
			font-size: 16px;
		}

		.info-titles {
			font-size: 14px;
			font-weight: 800;
		}

		.info-items-links {
			color: rgb(58, 65, 160);
			text-decoration: none;
			font-size: 13px;
		}

		.other-info-title {
			font-size: 16px;
			font-weight: 800;
		}

		.other-info-content {
			font-size: 14px;
			font-weight: 600;
		}

		.info-text-align {
			text-align: start;
			@media (max-width: 768px) {
				text-align: center;
			}
		}
	}
}
</style>